import React, { useRef, useState, useEffect } from 'react';
import PropTypes from 'prop-types';

// redux
import { useDispatch, useSelector } from 'react-redux';
import { resetState, rerenderTable } from './../../store/posConfigurationTileLayoutGroupTranslations.actions';

// components
import { ModalStepper } from 'dumb';
import PosConfigurationTileLayoutGroupTranslationsModalStep from './components/posConfigurationTileLayoutGroupTranslationsModalStep';

// services
import { addTileLayoutGroupTranslations } from './../../posConfigurationTileLayoutGroupTranslations.service';

// phrases
import phrases from './../../posConfigurationTileLayoutGroupTranslations.phrases';

const PosConfigurationTileLayoutGroupTranslationsModalBatch = ({ id, onClose }) => {
	const modalRef = useRef();
	const [loading, setLoading] = useState(false);
	const dispatch = useDispatch();
	const batchList = useSelector((store) => store.posConfigurationTileLayoutGroupTranslations.batchList);

	const onNext = () => {
		setLoading(true);

		const payload = batchList.map((entry) => ({
			pos_configuration_tile_layout_group: id,
			name: entry.name,
			language: entry.language?.value?.id ?? null,
		}));

		addTileLayoutGroupTranslations({ batch: payload })
			.then(() => {
				setLoading(false);
				dispatch(rerenderTable());
				onClose();
			})
			.catch(() => {
				setLoading(false);
			});
	};

	const steps = [
		{
			component: <PosConfigurationTileLayoutGroupTranslationsModalStep />,
			title: phrases.MODAL_TITLE,
			onBack: onClose,
			onNext,
			loading,
			isValid: true,
			confirmButtonLabel: phrases.SUBMIT,
			defaultStyles: false,
			noScroll: false,
		},
	];

	useEffect(() => {
		return () => {
			dispatch(resetState());
		};
	}, [dispatch]);

	return (
		<ModalStepper header={phrases.MODAL_TITLE} onClose={onClose} ref={modalRef} isOpen steps={steps} showStep={false} />
	);
};

PosConfigurationTileLayoutGroupTranslationsModalBatch.propTypes = {
	onClose: PropTypes.func,
	id: PropTypes.number,
};

export default PosConfigurationTileLayoutGroupTranslationsModalBatch;
